var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 0.625C3.39441 0.625 0.499878 3.54492 0.499878 7.125C0.499878 10.7305 3.39441 13.625 6.99988 13.625C10.58 13.625 13.4999 10.7305 13.4999 7.125C13.4999 3.54492 10.58 0.625 6.99988 0.625ZM6.99988 3.875C7.43152 3.875 7.81238 4.25586 7.81238 4.6875C7.81238 5.14453 7.43152 5.5 6.99988 5.5C6.54285 5.5 6.18738 5.14453 6.18738 4.6875C6.18738 4.25586 6.54285 3.875 6.99988 3.875ZM8.0155 10.375H5.98425C5.62878 10.375 5.37488 10.1211 5.37488 9.76562C5.37488 9.43555 5.62878 9.15625 5.98425 9.15625H6.3905V7.53125H6.18738C5.83191 7.53125 5.578 7.27734 5.578 6.92188C5.578 6.5918 5.83191 6.3125 6.18738 6.3125H6.99988C7.32996 6.3125 7.60925 6.5918 7.60925 6.92188V9.15625H8.0155C8.34558 9.15625 8.62488 9.43555 8.62488 9.76562C8.62488 10.1211 8.34558 10.375 8.0155 10.375Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.574704ad2de45a0856974f2b31a8d14c.svg";
export { ForwardRef as ReactComponent };